import { render, staticRenderFns } from "./ExpandedCostBasisReport.vue?vue&type=template&id=01791c7e&"
import script from "./ExpandedCostBasisReport.vue?vue&type=script&lang=ts&"
export * from "./ExpandedCostBasisReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports